export const ACTION_TYPE = {
  OPEN: 'open',
  CLOSE: 'close',
  ENROLL: 'enroll',
  DEPART: 'depart',
  NEARBY: 'nearby',
  ARRIVED: 'arrived',
  NO_ACTION: 'no_action',
}
